// third-party
import { presetPalettes } from '@ant-design/colors';

// project imports
import ThemeOption from './theme';
import { extendPaletteWithChannels } from 'utils/colorUtils';

const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];

// ==============================|| GREY COLORS BUILDER ||============================== //

function buildGrey() {
  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  return [...greyPrimary, ...greyAscent, ...greyConstant];
}

function buildDarkGrey() {
  const greyPrimary = [
    '#0b1120',
    '#111827',
    '#1f2937',
    '#273449',
    '#3b4658',
    '#5b6472',
    '#8b94a3',
    '#c3cad5',
    '#d8dee8',
    '#eef2f7',
    '#ffffff'
  ];
  const greyConstant = ['#151c2b', '#253149'];

  return [...greyPrimary, ...greyAscent, ...greyConstant];
}

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export function buildPalette(presetColor) {
  const lightColors = { ...presetPalettes, grey: buildGrey() };
  const lightPaletteColor = ThemeOption(lightColors, presetColor);
  const darkColors = { ...presetPalettes, grey: buildDarkGrey() };
  const darkPaletteColor = ThemeOption(darkColors, presetColor);

  const commonColor = { common: { black: '#000', white: '#fff' } };

  const extendedLight = extendPaletteWithChannels(lightPaletteColor);
  const extendedDark = extendPaletteWithChannels(darkPaletteColor);
  const extendedCommon = extendPaletteWithChannels(commonColor);

  return {
    light: {
      mode: 'light',
      ...extendedCommon,
      ...extendedLight,
      text: {
        primary: extendedLight.grey[700],
        secondary: extendedLight.grey[500],
        disabled: extendedLight.grey[400]
      },
      action: { disabled: extendedLight.grey[300] },
      divider: extendedLight.grey[200],
      background: {
        paper: extendedLight.grey[0],
        default: extendedLight.grey.A50
      }
    },
    dark: {
      mode: 'dark',
      ...extendedCommon,
      ...extendedDark,
      text: {
        primary: '#eef2f7',
        secondary: '#aeb8c7',
        disabled: '#6b7280'
      },
      action: {
        hover: 'rgba(255, 255, 255, 0.06)',
        selected: 'rgba(22, 119, 255, 0.18)',
        disabled: '#4b5563',
        disabledBackground: '#1f2937'
      },
      divider: '#253149',
      background: {
        paper: '#111827',
        default: '#0b1120'
      }
    }
  };
}
